import { LabStainsState, StainsState } from "../reducers/frontLoaderReducers";
import { getStainByLabStainId } from "../utils/stainUtils";

const selectStainByLabStainId = (labStainId?: number) => {
  return ({
    stains,
    labStains,
  }: {
    stains: StainsState;
    labStains: LabStainsState;
  }) => getStainByLabStainId(labStainId, stains, labStains);
};

export default selectStainByLabStainId;
